<template>
  <mdc-dialog v-model="isOpen"
              class="mdc_dialog_wider"
              :title="'protocol.detail_reaction_session' | trans"
              :accept="'user.close' | trans"
              @cancel="close"
              @accept="close">

    <loader class="table-loader" v-if="!dataSet"></loader>
    
    <line-shaping-chart v-if="dataSet && dataSet.yLabels" class="row mt-2" v-bind:datasets="fetchDatasetForShapingChart(dataSet.data)"
                        key="shapingChart"
                        chart-id="shapingChart"
                        :xAxisLabel="'protocol.probe_by_session' | trans"
                        v-bind:y-labels="dataSet.yLabels"
                        :list-chart-date="dataSet.xLabels"
                        v-bind:show-legend="false"
                        v-bind:y-axes-begin-at-zero="true"
                        :height="380"
                        :all-axis-show="true"
                        :width=null
                        :aspect-ratio=false
    />
    <h4 class="chart__title mb-3" v-if="dataSet && dataSet.yLabels">{{'protocol.shaping_chart' | trans}} "{{dataSet.stage.description}}"</h4>


  </mdc-dialog>
</template>

<script>

  import Loader from '../../loader/components/Loader';
  import lang from '../../../lang/translator';
  import axios from 'axios';
  import forEach from 'lodash/forEach';
  import split from 'lodash/split';
  import moment from 'moment';
  import {LineChartDataset, LineShapingChart} from '../../../common/chart';



  export default {
    props: {

      'visible': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'stimulName': {
        type: String,
        default() {
          return '';
        },
      },
      'dataPoint': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'protocolId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'stageId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
    },
    data() {
      return {
        verticalLinePoint: [],
        apiUrl: '/protocols/assigned/',
        dataSet: null,
        valueMax: null,
      };
    },
    computed: {
      isOpen: {
        get() {
          return this.visible;
        },
        set() {
        },
      },
    },
    components: {Loader, LineChartDataset, LineShapingChart},
    mounted() {
      this.showChart();
    },
    methods: {
      close() {
        this.$emit('close');
      },

      toLocaleDate: function (date) {
        return moment(date*1000).format('DD.MM.YYYY')
      },
      
      

      async showChart() {
        let apiUrl = this.isVCD ? this.apiUrl + 'vcd/' : this.apiUrl;
        let url, params;

        url = this.apiUrl + 'shaping/' + this.protocolId + '/detailed-session-mensuration/'+ this.stageId;
        params = {
          date: this.dataPoint
        }
        
        
        let response = await axios.get(url, {
          params: params
        });
        this.dataSet = response.data.data;
      },

      fetchDatasetForShapingChart(data){
        let dataChart = [];

        forEach(data, chart => {
          dataChart.push(new LineChartDataset({
            data: chart,
            pointBorderWidth: 2
          }));

          let value = split(chart[0].y, '_');

          dataChart.push(new LineChartDataset({
            data: [
              {
                x: chart[0].x,
                y: value[0] + '_0',
              },
              {
                x: chart[chart.length - 1].x,
                y: value[0] + '_0',
              },
            ],
            pointRadius: 0,
            pointBackgroundColor: 'transparent',
            pointBorderColor: 'transparent',
            borderWidth: 2,
            borderDash: [12,10]
          }));

        });

        return dataChart;

      },

     

    },
  };
</script>


// WEBPACK FOOTER //
// src/modules/dashboardParent/components/ChartPopupShaping.vue